// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cardBox {
  background-color: #1e293b !important;
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  transition: 0.3s ease-in-out;
  color: #ffffff;
}

.cardBox:hover {
  transform: scale(1.02);
}

.cardtopic {
  margin-bottom: 12px;
  font-size: 18px;
  font-weight: 600;
  color: #ffffff;
}

.charts {
  margin-top: 40px;
  display: grid;
  gap: 20px;
}

/* Optional dark mode */
body {
  background-color: #0f172a;
  color: #ffffff;
}

/* Hide ApexCharts toolbar */
.apexcharts-toolbar {
  display: none !important;
}

/* Optional: dark tooltip style override if needed */
.apexcharts-tooltip {
  background-color: #1e293b !important;
  color: #ffffff !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/charts/chart.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA,4BAA4B;AAC5B;EACE,wBAAwB;AAC1B;;AAEA,oDAAoD;AACpD;EACE,oCAAoC;EACpC,yBAAyB;AAC3B","sourcesContent":[".cardBox {\n  background-color: #1e293b !important;\n  padding: 20px;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);\n  transition: 0.3s ease-in-out;\n  color: #ffffff;\n}\n\n.cardBox:hover {\n  transform: scale(1.02);\n}\n\n.cardtopic {\n  margin-bottom: 12px;\n  font-size: 18px;\n  font-weight: 600;\n  color: #ffffff;\n}\n\n.charts {\n  margin-top: 40px;\n  display: grid;\n  gap: 20px;\n}\n\n/* Optional dark mode */\nbody {\n  background-color: #0f172a;\n  color: #ffffff;\n}\n\n/* Hide ApexCharts toolbar */\n.apexcharts-toolbar {\n  display: none !important;\n}\n\n/* Optional: dark tooltip style override if needed */\n.apexcharts-tooltip {\n  background-color: #1e293b !important;\n  color: #ffffff !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
